import React from "react";

import CSSModules from "lib/utils/css-modules";
import st from "lib/utils/index";
import { Link, Button } from "lib/components/vendor";
import BalanceStatusLabel from "lib/components/BalanceStatusLabel";
import OrderStatusLabel from "lib/components/OrderStatusLabel";
import OrderAutomationModeIcon from "lib/components/OrderAutomationModeIcon";
import styles from "./OrdersListItem.less";

@CSSModules(styles)
export default class OrdersListItem extends React.PureComponent {
  render() {
    const {
      order,
      currentCompanyId,
      showStatus = true,
      showCustomerAsFirst = true,
      onApprove,
      onReject,
      actionPending,
    } = this.props;

    const itemDate = (
      <div styleName="item-date">
        {order.stock_starts_at && (
          <div styleName="slot-date">
            <div styleName="slot-date-day">{moment.parseZone(order.stock_starts_at).format("D")}</div>
            <div styleName="slot-date-month">{moment.parseZone(order.stock_starts_at).format("MMM")}</div>
            {!!order.stock_includes_time && (
              <div styleName="slot-date-time">{moment.parseZone(order.stock_starts_at).format(moment.TIME_FORMAT)}</div>
            )}
          </div>
        )}
        {order.stock_useby_starts_at && (
          <div styleName="useby-date">
            <div styleName="useby-date-start">{moment.parseZone(order.stock_useby_starts_at).format("D MMM")}</div>
            <div styleName="useby-date-sep">-</div>
            <div styleName="useby-date-end">
              {order.stock_useby_ends_at ? moment.parseZone(order.stock_useby_ends_at).format("D MMM") : "∞"}
            </div>
          </div>
        )}
        {!order.stock_starts_at && !order.stock_useby_starts_at && (
          <div styleName="useby-date">
            <div styleName="useby-date-blank">{I18n.t("papp.order.no_stock_date")}</div>
          </div>
        )}
      </div>
    );

    const itemImage = () => {
      let productImageUrl = st.getAttachmentImageUrl(order.product, "main_image", "thumb");
      if (productImageUrl.endsWith(".webp")) {
        productImageUrl = order.product.main_image_file.url;
      }
      return (
        <div styleName="item-image">
          <img src={productImageUrl} />
        </div>
      );
    };

    const itemContentCustomer = (
      <div styleName="item-customer">
        <div styleName="item-customer-meta-customer_name">
          <span styleName="item-id">#{order.id}: </span>
          {order.customer_display_name || I18n.t("papp.order.customer_name_placeholder")}
        </div>
        {!!order.persons_count && (
          <div styleName="item-customer-meta">
            <span className="with-icon">
              <span className="text">{order.persons_count}</span>
              <i className="icon material-icons">people</i>
            </span>
          </div>
        )}
        {order.agent && (
          <div styleName="item-customer-meta">
            <span className="with-icon">
              <i className="icon material-icons">share</i>
              <span className="text">{order.agent.name}</span>
            </span>
          </div>
        )}
        {order.company.id !== currentCompanyId && (
          <div styleName="item-customer-meta">
            <span className="with-icon">
              <i className="icon material-icons">account_balance</i>
              <span className="text">{order.company.name}</span>
            </span>
          </div>
        )}
      </div>
    );

    const itemContentProduct = (
      <div styleName="item-product">
        <div styleName="item-product-name">{order.product_name}</div>
        {order.product_variant_name && <div styleName="item-product-variant-name">{order.product_variant_name}</div>}
      </div>
    );

    const itemContentCouponCode = order.coupon_code_name && (
      <div styleName="item-coupon-code">
        <span className="with-icon">
          <i className="icon material-icons">label_outline</i>
          <span className="text">{order.coupon_code_name}</span>
        </span>
      </div>
    );

    const itemContent = showCustomerAsFirst ? (
      <div styleName="item-content">
        {itemContentCustomer}
        {itemContentProduct}
        {itemContentCouponCode}
      </div>
    ) : (
      <div styleName="item-content">
        {itemContentProduct}
        {itemContentCustomer}
        {itemContentCouponCode}
      </div>
    );

    const itemSide = (
      <div styleName="item-side">
        <div styleName="item-side-top">
          {order.canCallAction("approve") && st.authorize("approve", order) && (
            <div className="u-whiteSpaceNowrap">
              <Button
                color="red"
                size="tiny"
                content={I18n.t("papp.order.reject")}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onReject();
                }}
                disabled={actionPending}
              />
              &nbsp;
              <Button
                color="green"
                size="tiny"
                className="u-marginRightNone"
                content={I18n.t("papp.order.approve")}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onApprove();
                }}
                disabled={actionPending}
              />
            </div>
          )}
        </div>
        <div styleName="item-side-bottom">
          <div styleName="item-side-bottom-meta">
            <OrderAutomationModeIcon automatic={!order.manual} style={{ fontSize: "1.3em" }} />
          </div>

          {showStatus && (
            <div styleName="item-side-bottom-meta">
              <OrderStatusLabel shortLabel status={order.status} />
            </div>
          )}
          {order.product && order.product.product_type !== "coupon" && order.balance_status && (
            <div styleName="item-side-bottom-meta">
              <BalanceStatusLabel status={order.balance_status} />
            </div>
          )}

          {order.product && order.product.product_type !== "coupon" && order.total_amount_sum && (
            <div styleName="item-cart-value">
              <span className="with-icon">
                <i className="icon material-icons">shopping_cart</i>
                <span className="text">{st.formatMoney(order.total_amount_sum)}</span>
              </span>
            </div>
          )}
        </div>
      </div>
    );

    const itemStyleName = showCustomerAsFirst ? "item-customer-first" : "item-product-first";
    return (
      <Link as="a" to={`/c/${currentCompanyId}/orders/${order.id}/${order.token}`} styleName={itemStyleName}>
        {itemDate}
        {itemImage()}
        {itemContent}
        {itemSide}
        <div styleName="item-read-more-button">
          <i className="icon material-icons">chevron_right</i>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/OrdersListItem.jsx